import { render, staticRenderFns } from "./JumpToBottom.vue?vue&type=template&id=2b939c9e&scoped=true"
import script from "./JumpToBottom.vue?vue&type=script&lang=js"
export * from "./JumpToBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b939c9e",
  null
  
)

export default component.exports